import { apiPost } from '../../api'

export const save_recruitee = data => {
  return apiPost({
    endpoint: 'recruitment/save_recruitee',
    data: data
  })
}
